<template>
  <div>
    <v-main>
      <div style="background-color:; padding: 12px 48px;height: 100%;">
        <v-row style="padding:1% 2% 0%; height: 80px;">
          <v-col xs="10" sm="10" md="10" lg="10" style="padding-bottom:0">
            <h2>Special Points</h2>
          </v-col>
        </v-row>
        <v-divider style="padding-top:0;"></v-divider>
        <v-row>
          <v-col>
            <h3>Welcome Point</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-switch
              v-model="btnUpdateWelcome.btnStatusWel"
              class="mt-0"
              color="green lighten-2"
              hide-details
              label="สถานะการใช้งาน"
              @click="updateWel()"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4">
            <v-text-field
              v-model="dataWel.pointWel"
              label="คะแนนที่ต้องการแจก"
              type="number"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4">
            <v-btn @click="editWel()" color="primary">บันทึก</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="9" md="6" lg="6">
            <v-divider style="padding-top:0; margin: 0px 0px"></v-divider>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h3>Birthday Point</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-switch
              v-model="btnUpdateBirthday.btnStatusBirth"
              class="mt-0"
              color="green lighten-2"
              hide-details
              label="สถานะการใช้งาน"
              @click="updateBir()"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4">
            <v-text-field
              v-model="dataBirth.pointBirth"
              label="คะแนนที่ต้องการแจก"
              type="number"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="4"
            lg="4"
            style="padding: 0px 15px"
          >
            <v-text-field
              v-model="dataBirth.conditionPoint"
              label="เงื่อนไขในการรับภายในกี่วัน"
              type="number"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col
            style="padding: 0px 15px"
            cols="12"
            xs="12"
            sm="6"
            md="4"
            lg="4"
          >
            <v-btn @click="editBirth()" color="primary">บันทึก</v-btn>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api

export default {
  components: {},
  data () {
    return {
      session: this.$session.getAll(),
      btnUpdateWelcome: {
        btnStatusWel: ''
      },
      btnUpdateBirthday: {
        btnStatusBirth: ''
      },
      dataWel: {
        pointWel: ''
      },
      dataBirth: {
        conditionPoint: '',
        pointBirth: ''
      },
      ID: ''
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.getdataSpecialPoints()
  },
  methods: {
    getdataSpecialPoints () {
      axios
        .get(this.DNS_IP + '/special/get?shopId=' + this.session.data.shopId)
        .then(response => {
          let rs = response.data[0]
          console.log('rs', rs)
          this.ID = rs.id
          if (rs.btnStatusWel === 'True' || rs.btnStatusWel === 'true') {
            this.btnUpdateWelcome.btnStatusWel = true
          } else if (
            rs.btnStatusWel === 'False' ||
            rs.btnStatusWel === 'false'
          ) {
            this.btnUpdateWelcome.btnStatusWel = false
          }

          if (rs.btnStatusBirth === 'True' || rs.btnStatusBirth === 'true') {
            this.btnUpdateBirthday.btnStatusBirth = true
          } else if (
            rs.btnStatusBirth === 'False' ||
            rs.btnStatusBirth === 'false'
          ) {
            this.btnUpdateBirthday.btnStatusBirth = false
          }

          this.dataWel.pointWel = rs.pointWel
          this.dataBirth.pointBirth = rs.pointBirth
          this.dataBirth.conditionPoint = rs.conditionPoint
        })
    },
    editWel () {
      axios
        .post(this.DNS_IP + '/special/edit/' + this.ID, this.dataWel)
        .then(res => {
          if (res.data.status === true) {
            this.$swal({
              title: 'อัพเดทสถานะ',
              text: 'สำเร็จ',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })
          }
        })
    },
    editBirth () {
      axios
        .post(this.DNS_IP + '/special/edit/' + this.ID, this.dataBirth)
        .then(res => {
          if (res.data.status === true) {
            this.$swal({
              title: 'อัพเดทสถานะ',
              text: 'สำเร็จ',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })
          }
        })
    },
    updateWel () {
      axios
        .post(this.DNS_IP + `/special/edit/${this.ID}`, this.btnUpdateWelcome)
        .then(res => {
          //   console.log(this.updateWelcome.btnStatusWel)
          if (res.data.status === true) {
            this.$swal({
              title: 'อัพเดทสถานะ',
              text: 'สำเร็จ',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })
            console.log(
              this.DNS_IP + `/special/edit/${this.ID}`,
              this.updateWelcome.btnStatusWel
            )
          }
        })
    },
    updateBir () {
      axios
        .post(this.DNS_IP + `/special/edit/${this.ID}`, this.btnUpdateBirthday)
        .then(res => {
          if (res.data.status === true) {
            this.$swal({
              title: 'อัพเดทสถานะ',
              text: 'สำเร็จ',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })
          }
        })
    }
  }
}
</script>
<style scoped>
h3 {
  font-size: 18.72px !important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
  min-width: 64px;
  padding: 0 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/System/pointFree.vue